import { render } from "./buttonPrimary.vue?vue&type=template&id=2eb3feec&scoped=true"
import script from "./buttonPrimary.vue?vue&type=script&lang=js"
export * from "./buttonPrimary.vue?vue&type=script&lang=js"

import "./buttonPrimary.vue?vue&type=style&index=0&id=2eb3feec&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\honza\\Local Sites\\cestakzamestnani\\app\\public\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb3feec"]])

export default __exports__